import { requestCurrentUser, updateOwnUser } from './UserAction';

function isRejected(response) {
  return response?.status === 401 || response?.status === 404;
}

export async function validateCurrentAccount(dispatch, idToken) {
  const userDetails = await dispatch(requestCurrentUser());

  if (isRejected(userDetails) || userDetails?.errors) {
    return {
      isRejected: isRejected(userDetails),
      rejectionSource: 'currentUser',
      status: userDetails?.status
    };
  }

  const updatedUser = await dispatch(updateOwnUser(idToken));
  return {
    isRejected: isRejected(updatedUser),
    rejectionSource: 'updateOwnUser',
    status: updatedUser?.status
  };
}